export const FETCH_CONSULTATIONS = 'FETCH_CONSULTATIONS';
export const FETCH_CONSULTATION = 'FETCH_CONSULTATION';
export const CREATE_CONSULTATION = 'CREATE_CONSULTATION';
export const UPDATE_CONSULTATION = 'UPDATE_CONSULTATION';
export const CANCEL_CONSULTATION = 'CANCEL_CONSULTATION';
export const COMPLETE_CONSULTATION = 'COMPLETE_CONSULTATION';
export const FETCH_AGORA_CONSULTATION = 'FETCH_AGORA_CONSULTATION';